import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "../../utils/analytics";

/**
 * Sends one GA4 page_view per route.
 *
 * A single-page app navigates without reloading, so gtag.js only ever sees the URL the browser
 * first opened. Without this, "visitors" would be right but every journey through the site would
 * look like a one-page bounce — which is exactly the thing worth knowing after an ad campaign.
 *
 * Renders nothing; must sit inside the router so useLocation() has a context to read.
 */
const RouteAnalytics = () => {
  const { pathname, search } = useLocation();

  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => { trackPageView(pathname, search); }, [pathname, search]);

  return null;
};

export default RouteAnalytics;
